/**
 * Name: DELETE CUSTOMER SCHEDULE Saga
 * Author: @Gaurav
 * Date: 22-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller(`/v1/admin/playlists/customer/${payload.customerId}/playlist/${payload.playlistId}/schedule`, 'DELETE');
};

export default function* watchRequest() {
  yield takeLatest('DELETE_CUSTOMER_SCHEDULE', function* performAction(action) {
    yield put({ type: 'DELETE_CUSTOMER_SCHEDULE_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'DELETE_CUSTOMER_SCHEDULE_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'DELETE_CUSTOMER_SCHEDULE_FAILED', payload: error });
    }
  });
}

